// src/index.js
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { Provider } from "react-redux";
import store from "./redux/store";

// MSAL
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./azure_auth/authConfig_new";

// MUI
import { ThemeProvider, CircularProgress } from "@mui/material";
import { theme } from "./assets/styles/theme";

// Routing & Toastr
import { BrowserRouter } from "react-router-dom";
import ReduxToastr from "react-redux-toastr";

// Tu App y Auth
import App from "./App";
import { AuthProvider } from "./azure_auth/AuthKit";
import LoginWidget from "./LoginWidget";

// Error Boundary, i18n y métricas
import ErrorBoundary from "./azure_auth/ErrorBoundary";
import "./i18n";
import reportWebVitals from "./reportWebVitals";

// 1️⃣ Crea la instancia UNA sola vez
const msalInstance = new PublicClientApplication(msalConfig);

// 2️⃣ Inicializa la instancia ANTES de montar React (solo popup flows)
msalInstance.initialize()
  .then(() => {
    console.log("✅ MSAL instance initialized");
    ReactDOM.render(
      <React.StrictMode>
        <ErrorBoundary>
          <MsalProvider instance={msalInstance}>
            <AuthProvider>
              <Provider store={store}>
                <BrowserRouter>
                  <ThemeProvider theme={theme}>
                    <React.Suspense
                      fallback={
                        <div className="text-center col-12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', paddingTop: '80px', gap: '16px' }}>
                          <CircularProgress size={40} thickness={4} />
                          <p>Loading…</p>
                        </div>
                      }
                    >
                      <App />
                    </React.Suspense>
                  </ThemeProvider>
                  <ReduxToastr
                    timeOut={4000}
                    newestOnTop={false}
                    preventDuplicates
                    position="top-right"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                    closeOnToastrClick
                  />
                </BrowserRouter>
              </Provider>
            </AuthProvider>
          </MsalProvider>
        </ErrorBoundary>
      </React.StrictMode>,
      document.getElementById("root")
    );
    reportWebVitals();
  })
  .catch((err) => {
    console.error("❌ MSAL initialization failed:", err);
    ReactDOM.render(
      <ErrorBoundary>
        <div style={{ padding: 20, color: "#900" }}>
          <h1>No se pudo inicializar MSAL</h1>
          <pre style={{ whiteSpace: "pre-wrap" }}>{err.toString()}</pre>
        </div>
      </ErrorBoundary>,
      document.getElementById("root")
    );
  });


// // src/index.js
// import React, { Suspense, useEffect, useState } from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "react-redux-toastr/lib/css/react-redux-toastr.min.css";

// // Redux
// import { Provider } from "react-redux";
// import store from "./redux/store";

// // MSAL
// import { PublicClientApplication } from "@azure/msal-browser";
// import { MsalProvider } from "@azure/msal-react";
// //import { msalConfig } from "./azure_auth/authConfig";
// // import { msalConfig } from "./components/home/loginRequestText";

// // MUI
// import { ThemeProvider, CircularProgress } from "@mui/material";
// import { theme } from "./assets/styles/theme";

// // Router
// import { BrowserRouter } from "react-router-dom";

// // Para notificaciones Toastr
// import ReduxToastr from "react-redux-toastr";

// // Tu componente principal
// import App from "./App";

// // (Opcional) i18n, si usas
// import "./i18n";

// import reportWebVitals from "./reportWebVitals";
// import { msalConfig } from "./azure_auth/authConfig_new";
// import { AuthProvider } from "./azure_auth/AuthKit";
// import LoginWidget from "./LoginWidget";

// function Root() {
//   // Creamos la instancia de MSAL UNA sola vez
//   // const [msalInstance] = useState(() => new PublicClientApplication(msalConfig));
//   const msalInstance = new PublicClientApplication(msalConfig);

//   // const [msalInitialized, setMsalInitialized] = useState(false);

//   // // Llamamos a initialize() para habilitar .accounts y .inProgress
//   // useEffect(() => {
//   //   msalInstance
//   //     .initialize()
//   //     .then(() => {
//   //       console.log("MSAL instance initialized");
//   //       setMsalInitialized(true);
//   //     })
//   //     .catch((err) => {
//   //       console.error("Error initializing MSAL:", err);
//   //     });
//   // }, [msalInstance]);

//   // if (!msalInitialized) {
//   //   // Mostrar un fallback mientras MSAL se inicializa
//   //   return (
//   //     <div className="text-center col-12" style={{ marginTop: 50 }}>
//   //       <p>Loading MSAL...</p>
//   //       <CircularProgress />
//   //     </div>
//   //   );
//   // }

//   // Una vez inicializado => renderizamos la aplicación
//   return (
//     <React.StrictMode>
//       <MsalProvider instance={msalInstance}>
//         <AuthProvider>
//           <LoginWidget/>
//           <Provider store={store}>
//             <BrowserRouter>
//               <ThemeProvider theme={theme}>
//                 <Suspense
//                   fallback={
//                     <div className="text-center col-12">
//                       <p>Loading...</p>
//                       <CircularProgress />
//                     </div>
//                   }
//                 >
//                   <App />
//                 </Suspense>
//               </ThemeProvider>

//               <ReduxToastr
//                 timeOut={4000}
//                 newestOnTop={false}
//                 preventDuplicates
//                 position="top-right"
//                 transitionIn="fadeIn"
//                 transitionOut="fadeOut"
//                 closeOnToastrClick
//               />
//             </BrowserRouter>
//           </Provider>
//         </AuthProvider>
//       </MsalProvider>
//     </React.StrictMode>
//   );
// }

// ReactDOM.render(<Root />, document.getElementById("root"));

// // Opcional, métricas
// reportWebVitals();
